// extracted by mini-css-extract-plugin
export default {"pageBg":"AboutPage_pageBg__udc4m"};